import { UserAuth } from 'features/auth';

export const AuthPage = () => <UserAuth />;
